import { createContext } from 'react';

import type { Dispatch, SetStateAction } from 'react';
import type { OptimizationModelInterface } from 'sonata-static-storage/lib/schemas/campaign/optimizationModel.schema';

export type SonataMORESharedContextState = {
  currentCampaignOptimizationModel?: OptimizationModelInterface;
  currentSelectedOptimizationModel?: Record<string, any>;
  models: Record<string, any>[];
  optimizationModelKpiCatalog?: Record<string, any>[];
  optimizationModelKpiLevel?: string;
  selectedOptimizationModelKpi?: string;
};

export interface SonataMOREContextInterface extends SonataMORESharedContextState {
  setContext: Dispatch<SetStateAction<SonataMORESharedContextState>>;
}

export const SonataMOREContext = createContext<SonataMOREContextInterface>({
  models: [],
  setContext: (): void => {
    throw new Error('SonataMOREContext.setContext must be overridden by the Provider');
  }
});
